import { render } from "./formAchat.vue?vue&type=template&id=f109479a&scoped=true"
import script from "./formAchat.vue?vue&type=script&lang=js"
export * from "./formAchat.vue?vue&type=script&lang=js"

import "./formAchat.vue?vue&type=style&index=0&id=f109479a&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f109479a"]])

export default __exports__